// extracted by mini-css-extract-plugin
module.exports = {"header":"StandHeader2-header-f14d"};